import { Tooltip } from "@cloudflare/kumo";
import { timeAgo } from "./workflow-format";

// Adapted from workers-sdk's local-explorer-ui workflow Timestamp, taking
// the epoch milliseconds this runtime records.

function formatShort(timestamp: number): string {
  const d = new Date(timestamp);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

function formatFull(timestamp: number): string {
  return new Date(timestamp).toLocaleString("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZoneName: "short"
  });
}

export function WorkflowTimestamp({ value }: { value: number | undefined }) {
  if (!value) {
    return <span className="text-sm text-kumo-subtle">—</span>;
  }

  return (
    <Tooltip
      content={
        <div className="space-y-1 text-xs">
          <div>{formatFull(value)}</div>
          <div className="text-kumo-subtle">{timeAgo(value)}</div>
        </div>
      }
    >
      <span className="text-sm whitespace-nowrap text-kumo-subtle">
        {formatShort(value)}
      </span>
    </Tooltip>
  );
}
